import React, { memo } from 'react';

import CatchError from 'components/CatchError';
import BellNotification from 'components/Shared/Common/BellNotification';
import ToggleSound from 'components/Shared/Common/SoundButton/container';
import { StyledStatusSelector } from 'components/LeftMenu/Header/style';
import UserStatusSelector from 'components/Shared/Common/UserStatusSelector';

const Header = () => (
    <CatchError>
        <StyledStatusSelector className="s-user" id="profile">
            <UserStatusSelector />
            <div className="icon-container">
                <ToggleSound />
                <BellNotification />
            </div>
        </StyledStatusSelector>
    </CatchError>
);

export default memo(Header);
